<template>
  <div id="setting-result">
    <b-row
      class="card-setting-result font-medium-5 text-black font-weight-bolder"
    >
      <b-col cols="6">
        <div class="d-flex align-item-center">
          <b-form-checkbox
            v-model="scoreData.isSetScore"
            class="mr-0 custom-control-success mr-4"
            name="is-rtl"
            :value="true"
            switch
            inline
          />
          <div class="mt-5px ml-4">กำหนดคะแนน และแสดงผลลัพธ์</div>
        </div>
      </b-col>
      <b-col cols="6" v-if="scoreData.isSetScore">
        <div class="d-flex align-item-center justify-content-end">
          <div class="mr-4">Total Score</div>
          <div class="total-result-wrp">
            <div>{{ scoreData.totalScore }}</div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row class="setting-point-wrp" v-if="scoreData.isSetScore">
      <b-col cols="12">
        <div no-body v-for="(item, idx) in scoreData.result" :key="idx">
          <div class="bg-white container-wrp px-5 p-2 mt-3">
            <b-row class="mb-0">
              <b-col>
                <div class="font-medium-5 required">Range</div>
                <div class="d-flex justify-content-between">
                  <div class="d-flex justify-content-center align-item-center">
                    <input-spin-quiz
                      :isDisabled="!scoreData.isEdit"
                      :nameValue="scoreData.minName"
                      :isText="'คะแนน'"
                      :numValue="item.minValue"
                      :maxValue="item.maxValue"
                      :minValue="
                        idx > 0 ? scoreData.result[idx - 1].maxValue + 1 : 0
                      "
                      @update-number="
                        onUpdateMinScore($event, item, scoreData.result)
                      "
                      :isInputDisabled="false"
                      :inputId="`min-${idx}`"
                    />
                    <span class="mx-1">—</span>
                    <input-spin-quiz
                      :isDisabled="!scoreData.isEdit"
                      :nameValue="scoreData.maxName"
                      :isText="'คะแนน'"
                      :numValue="item.maxValue"
                      :maxValue="scoreData.totalScore"
                      :minValue="
                        idx > 0 ? scoreData.result[idx - 1].maxValue + 1 : 0
                      "
                      @update-number="
                        onUpdateMaxScore($event, item, scoreData.result)
                      "
                      :isInputDisabled="false"
                      :inputId="`max-${idx}`"
                    />
                  </div>
                  <div
                    v-if="scoreData.result.length > 1"
                    class="cursor-pointer"
                    :class="!scoreData.isEdit ? 'bypass cursor-defualt' : ''"
                  >
                    <icon-trash
                      class="w-100"
                      @click.native="onRemoveSetResult(item)"
                    />
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="6">
                <div>
                  <span class="mr-2 font-medium-5">Cover Banner</span>
                  <span class="desc-title font-medium-5"
                    >(Format JPG, JPEG, PNG Max 2 Mb)</span
                  >
                </div>
                <image-upload
                  :class="!scoreData.isEdit ? 'bypass' : ''"
                  :removable="true"
                  :image-url="item.bannerImage.url"
                  @onUpload="onUploadBanner($event, item)"
                />
              </b-col>
              <b-col cols="6">
                <div>
                  <b-form-group
                    :label="'Title'"
                    label-for="title"
                    label-class="font-medium-5 required"
                  >
                    <b-form-input
                      :disabled="!scoreData.isEdit"
                      v-model="item.name"
                      placeholder="Please specify"
                      class="input-wrp"
                    />
                  </b-form-group>
                  <b-form-group
                    :label="'Description'"
                    label-for="description"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      :disabled="!scoreData.isEdit"
                      v-model="item.desc"
                      placeholder="Please specify"
                      class="input-wrp"
                    />
                  </b-form-group>
                  <b-form-group
                    :label="'Note'"
                    label-for="note"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      :disabled="!scoreData.isEdit"
                      v-model="item.note"
                      placeholder="Please specify"
                      class="input-wrp"
                    />
                  </b-form-group>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div>
                  <b-tabs class="custom-tab flex-stretch h-100">
                    <b-tab
                      :title="'Thai'"
                      title-link-class="font-medium-5"
                      lazy
                      class="tab-thai-wrp"
                    >
                      <quill-editor
                        :disabled="!scoreData.isEdit"
                        v-model="item.termTh"
                        class="custom-quill-editor flex-stretch h-100"
                      />
                    </b-tab>
                    <b-tab
                      :title="'English'"
                      title-link-class="font-medium-5"
                      lazy
                      class="tab-eng-wrp"
                    >
                      <quill-editor
                        :disabled="!scoreData.isEdit"
                        v-model="item.termEng"
                        class="custom-quill-editor flex-stretch h-100"
                      />
                    </b-tab>
                  </b-tabs>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <div class="d-flex justify-content-center w-100">
        <div>
          <div>
            <div
              class="add-result"
              @click="$emit('addResult')"
              :class="[
                checKValidScoreLength ? 'add-result-disabled' : 'add-result',
              ]"
            >
              <icon-plus />
            </div>
          </div>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import {
  ref,
  reactive,
  getCurrentInstance,
  computed,
  watch,
  onBeforeMount,
} from "@vue/composition-api";
import InputSpinQuiz from "@/views/components/input-spin/InputSpinQuiz.vue";
import ImageUpload from "../../../quiz-info/Components/ImageUpload.vue";
import IconTrash from "@/@core/components/svg/common/IconTrash.vue";
import IconPlus from "@core/components/svg/common/IconPlus.vue";
export default {
  components: { InputSpinQuiz, ImageUpload, IconTrash, IconPlus },
  props: {
    scoreData: { type: Object, default: {} },
    maxValueBefore: { type: String, default: null },
  },
  setup(props) {
    const vm = getCurrentInstance().proxy;

    const onUploadBanner = (image, scoreObj) => {
      vm.$emit("onUploadBanner", image, scoreObj);
    };

    const onUpdateMinScore = (minValue, scoreObj, scoreArr) => {
      vm.$emit("onUpdateMinScore", minValue, scoreObj, scoreArr);
    };

    const onUpdateMaxScore = (maxValue, scoreObj, scoreArr) => {
      vm.$emit("onUpdateMaxScore", maxValue, scoreObj, scoreArr);
    };

    const onRemoveSetResult = (item) => {
      const index = props.scoreData.result.indexOf(item);
      vm.$emit("onRemoveSetResult", props.scoreData.result, index);
    };

    const checKValidScoreLength = computed(() => {
      let lastIndex = props.scoreData.result.length - 1;

      return (
        props.scoreData.result[lastIndex]?.maxValue ==
        props.scoreData.totalScore
      );
    });

    onBeforeMount(() => {
      props.scoreData.result.map((o) => {
        if (o.maxValue > props.scoreData.totalScore) {
          props.scoreData.result.splice(0);
          if (props.scoreData.result.length == 0) {
            props.scoreData.result.push({
              minValue: props.maxValueBefore || 1,
              maxValue: props.maxValueBefore || 1,
              bannerImage: { file: null, url: null },
              name: "",
              desc: "",
              note: "",
              termEng: "",
              termTh: "",
            });
          }
        }
      });
    });

    return {
      onUploadBanner,
      onUpdateMinScore,
      onUpdateMaxScore,
      onRemoveSetResult,
      checKValidScoreLength,
    };
  },
};
</script>

<style  scoped>
@import "~@/assets/css/pages/survey/score.css";

#setting-result .desc-title {
  color: #cecece;
}
</style>

<style lang="scss" scoped>
#setting-result ::v-deep {
  .nav-tabs {
    height: 52px !important;
    background-color: transparent !important;
    border-radius: 1.4rem;
    padding: 0 !important;
  }

  .custom-tab .nav-tabs .nav-link.active {
    background-color: #e2e2e2 !important;
    border-bottom: none !important;
    color: #000000 !important;
    font-weight: bold;
    height: 40px !important;
  }

  .custom-tab .nav-tabs .nav-link {
    background: #f3f3f3 !important;
    border-radius: 1rem 1rem 0 0;
    padding: 0.4rem 2rem;
    margin: 0 !important;
    color: #000000 !important;
    font-weight: bold;
    height: 40px !important;
  }

  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    background-color: transparent;
    border-color: #dae1e7 #dae1e7 transparent;
  }

  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    background-color: transparent;
    border-color: #dae1e7 #dae1e7 transparent;
  }

  .nav-tabs > .nav-item:nth-child(1) > .nav-link {
    border-top-right-radius: 0 !important;
  }
  .nav-tabs > .nav-item:nth-child(2) > .nav-link {
    border-top-left-radius: 0 !important;
  }

  .custom-tab > div:nth-child(1) {
    top: 17px !important;
    z-index: 0 !important;
  }

  .custom-quill-editor {
    position: relative;
    z-index: 99;
  }
}
</style>

